<template>
	<div class="flex w-full items-center justify-between p-2 bg-gray-100 fixed top-0 left-0 z-[100] h-14 shadow-md">
	<!-- <div class="sticky w-full items-center justify-between p-2 bg-gray-100 flex inset-0 z-[100] h-14 shadow-md"> -->
		<div class="flex-1">
			<UButton 
				v-if="is_tg_back_button_visible"
				color="primary"
				variant="solid"
				icon="i-heroicons-arrow-left-20-solid"
				size="lg"
				@click="handleBackClick"
			/>
			<div v-if="!is_tg_back_button_visible">&nbsp;</div>
		</div>

		<div class="flex-1 text-center font-semibold text-sm">Telegram MiniApp</div>
		<div class="flex-1 text-right">&nbsp;</div>
		
	</div>
</template>

<script setup lang="ts">
import { UButton } from '#components';


const { getBackButtonHandler } = useTelegramBackButton();

const main_store = useMainStore();
const { is_tg_back_button_visible } = storeToRefs(main_store);

watch(
	() => is_tg_back_button_visible,
	(newValue) => {
		if (newValue.value) {
			console.error('Back button is visible');
		} else {
			console.error('Back button is hidden');
		}
	}
);

const handleBackClick = async () => {
	console.log('Back button clicked');
	const handler = getBackButtonHandler();
	console.log('Back button handler:', handler);
	if (handler) {
		try {
			await handler();
		} catch (error) {
			console.error('Error in virtual BackButton handler:', error);
		}
	}
};
</script>